import { useQuery } from '@tanstack/react-query'
import type { ApiResponse, ComprehensiveScorecardData, ColumnCount, LabelType, Timeframe } from '@/types'

export function useComprehensiveScorecard(
  columns: ColumnCount = 8,
  labelType: LabelType = 'date_range',
  periodTimeframe?: Timeframe
) {
  return useQuery({
    queryKey: ['scorecard', 'comprehensive', columns, labelType, periodTimeframe],
    queryFn: async (): Promise<ComprehensiveScorecardData> => {
      const params = new URLSearchParams({
        columns: String(columns),
        label_type: labelType,
      })
      if (periodTimeframe) {
        params.set('period_timeframe', periodTimeframe)
      }
      const res = await fetch(`/api/scorecard/comprehensive?${params}`)
      const data: ApiResponse<ComprehensiveScorecardData> = await res.json()
      if (!data.success) throw new Error(data.error || 'Failed to fetch scorecard')
      return data.data!
    },
    staleTime: 30000, // 30 seconds
  })
}
